import {createApp} from 'vue';
import ImageViewer from "./ImageViewer.vue";
import {createBootstrap} from 'bootstrap-vue-next';
import ImageManager from "./ImageManager.vue";
import {VueDraggable} from "vue-draggable-plus";

// ImageViewer start script
$(document).ready($('#image-viewer-container').length&&function() {
    const container = $('#image-viewer-container');

    createApp(ImageViewer, container.data())
        .use(createBootstrap())
        .mount(container[0]);
});

// ImageManager start script
$(document).ready($("#image-manager-container").length&&function () {
    const container = $("#image-manager-container");

    const config = {
        initialImages: container.data("images") ?? [],
        uploadUrl: container.data("uploadUrl"),
        deleteUrl: container.data("deleteUrl"),
        reorderUrl: container.data("reorderUrl"),
        editable: Boolean(container.data("editable")),
        emptyMessage: container.data('emptyMessage'),
        viewTitle: container.data('viewTitle'),
    };

    // validate required data
    if (!config.uploadUrl || !config.deleteUrl || !config.reorderUrl) {
        console.error("Missing required configuration");
        return;
    }

    createApp(ImageManager, config)
        .use(createBootstrap())
        .component("Draggable", VueDraggable)
        .mount(container[0]);
})

import Choices from "choices.js";

$(document).ready(/\/faculty-management\/room\/(\d+\/)?(create|edit)/
    .test(window.location.pathname)&&function() {
    var removalFunction = function (e) {
        var container = $(this).closest(".element-row-container");
        $(this).closest(".element-row").remove();
    };
    $(".btn-add-row").click(function (e) {
        var container = $(this).closest("div.card").find(".element-row-container");
        var currentCount = container.find(".element-row").length;
        var template = container.data('template');
        template = template.replace(/__index__/g, currentCount);
        container.append(template);
        container.find(".js-choice").each(function () {
            this.choices = new Choices(this, window.choicesConfig(this))
        });
        container.find(".btn-remove-row:last").click(removalFunction);
    });
    $(".element-row-container .btn-remove-row").click(removalFunction);
});
